import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SurveySectionProps {
  title: string
  count?: number
  dotColor?: string
  defaultOpen?: boolean
  children: React.ReactNode
}

export function SurveySection({
  title,
  count,
  dotColor = 'bg-gray-400',
  defaultOpen = true,
  children,
}: SurveySectionProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="border-t border-gray-100 pt-4 first:border-t-0 first:pt-0">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-2 text-start hover:opacity-90"
      >
        <ChevronDown
          className={cn(
            'h-4 w-4 text-gray-500 shrink-0 transition-transform',
            open && 'rotate-180'
          )}
        />
        <span className={cn('w-2 h-2 rounded-full shrink-0', dotColor)} />
        <span className="text-sm font-semibold text-gray-900">
          {title}
          {count != null ? ` (${count})` : ''}
        </span>
      </button>
      {open && <div className="mt-3 space-y-3">{children}</div>}
    </div>
  )
}
